import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import './ViewProject.css'; // Add this for custom styles

const ViewProject = () => {
    const { projectId } = useParams();
    const [project, setProject] = useState({});
    const [departments, setDepartments] = useState([]);
    const [contributors, setContributors] = useState([]);
    const [showReviewForm, setShowReviewForm] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [users, setUsers] = useState([]);
    const [selectedReviewer, setSelectedReviewer] = useState('');
    const [rating, setRating] = useState(0); // State for rating


    // Fetch project details
    useEffect(() => {
        if (projectId) {
            fetch(`${process.env.REACT_APP_API_BASE_URL}/api/projects/${projectId}`)
                .then(response => response.json())
                .then(data => setProject(data))
                .catch(error => console.error('Error fetching project details:', error));
        }
    }, [projectId]);

    // Fetch users for the "Reviewed By" dropdown
    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_BASE_URL}/api/users`)
            .then((response) => response.json())
            .then((data) => setUsers(data))
            .catch((error) => console.error('Error fetching users:', error));
    }, []);

    // Fetch departments for the project
    useEffect(() => {
        if (projectId) {
            fetch(`${process.env.REACT_APP_API_BASE_URL}/api/project-departments/${projectId}`)
                .then(response => response.json())
                .then(data => setDepartments(data.departments))
                .catch(error => console.error('Error fetching project departments:', error));
        }
    }, [projectId]);

    // Fetch contributors for the project
    useEffect(() => {
        if (projectId) {
            fetch(`${process.env.REACT_APP_API_BASE_URL}/api/project-contributors/${projectId}`)
                .then(response => response.json())
                .then(data => setContributors(data.contributors))
                .catch(error => console.error('Error fetching project contributors:', error));
        }
    }, [projectId]);

    const handleReviewSubmit = (event) => {
        event.preventDefault();
        const formData = new FormData(event.target);
        const reviewData = Object.fromEntries(formData.entries());

        reviewData.rating = rating;

        fetch(`${process.env.REACT_APP_API_BASE_URL}/api/reviews/${projectId}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ ...reviewData })
        })
            .then(response => {
                if (response.ok) {
                    setSuccessMessage('Review submitted successfully!');
                    setErrorMessage('');
                    setShowReviewForm(false);
                    setRating(0);
                } else {
                    return response.text().then(text => { throw new Error(text); });
                }
            })
            .catch(error => {
                setErrorMessage('Failed to submit review: ' + error.message);
                setSuccessMessage('');
            });
    };

    return (
        <div className="container mt-4">
            <h3>Project Details for {projectId}</h3>
            <div className="card mb-3">
                <div className="card-body">
                    <p><strong>TRL Level:</strong> {project.trlLevel}</p>
                    <p><strong>Project ID:</strong> {project.projId}</p>
                    <p><strong>Title:</strong> {project.projTitle}</p>
                    <p><strong>Summary:</strong> {project.projSummary}</p>
                    <p><strong>Lab:</strong> {project.labId}</p>
                    <p><strong>Project Type:</strong> {project.projType}</p>
                    <p><strong>Utilization:</strong> {project.projUtilization}</p>
                    <p><strong>Initial Fund:</strong> {project.projInitialFund}</p>
                    <p><strong>Start Date:</strong> {project.projStartDate}</p>
                    <p><strong>End Date:</strong> {project.projEndDate}</p>
                </div>
            </div>

            {/* Departments List */}
            <h5>Departments:</h5>
            <ul className="list-group mt-3">
                {Array.isArray(departments) && departments.length > 0 ? (
                    departments.map((dept) => (
                        <li key={dept.deptId} className="list-group-item d-flex justify-content-between align-items-center">
                            {dept.deptId} {dept.deptName}
                        </li>
                    ))
                ) : (
                    <li className="list-group-item">No Departments Found</li>
                )}
            </ul>

            {/* Contributors List */}
            <h5>Contributors:</h5>
            <ul className="list-group mt-3">
                {Array.isArray(contributors) && contributors.length > 0 ? (
                    contributors.map((contributor) => (
                        <li key={contributor.userId} className="list-group-item d-flex justify-content-between align-items-center">
                            {contributor.userId} {contributor.username}
                        </li>
                    ))
                ) : (
                    <li className="list-group-item">No Contributors Found</li>
                )}
            </ul>

           {/* Button to toggle the review form */}
{["1", "2", "3", "4", "5"].includes(sessionStorage.getItem("access_level")) && (
  <button 
    className="btn btn-primary mt-3" 
    onClick={() => setShowReviewForm(!showReviewForm)}
  >
    {showReviewForm ? 'Hide Review Form' : 'Review'}
  </button>
)}

            {/* Success or Error message */}
            {successMessage && <p className="alert alert-success mt-2">{successMessage}</p>}
            {errorMessage && <p className="alert alert-danger mt-2">{errorMessage}</p>}

            {/* Review Form Section */}
            {showReviewForm && (
                <div className="mt-4">
                    <h4>Review Form</h4>
                    <form onSubmit={handleReviewSubmit}>
                        <div className="mb-3">
                            <label className="form-label">Comments:</label>
                            <textarea className="form-control" name="comments" maxLength="300" required />
                        </div>
                        <div className="mb-3">
                            <label className="form-label">Actionable Insights:</label>
                            <textarea className="form-control" name="actionableInsights" maxLength="200" required />
                        </div>
                         {/* Numbered Rating */}
                         <div className="mb-3">
                            <label className="form-label">Rating:</label>
                            <div className="rating-numbers">
                                {[1, 2, 3, 4, 5,6,7,8,9,10].map((num) => (
                                    <label key={num}>
                                        <input
                                            type="radio"
                                            name="rating"
                                            value={num}
                                            checked={rating === num}
                                            onChange={(e) => setRating(Number(e.target.value))}
                                            required
                                        />
                                        <span className="number">{num}</span>
                                    </label>
                                ))}
                            </div>
                        </div>

                        <div className="mb-3">
                            <label className="form-label">Remarks:</label>
                            <textarea className="form-control" name="remarks" maxLength="300" required />
                        </div>
                        {/* Reviewed By Dropdown */}
                        <div className="mb-3">
                            <label className="form-label">Reviewed By:</label>
                            <select
                                className="form-select"
                                name="reviewedBy"
                                value={selectedReviewer}
                                onChange={(e) => {
                                    setSelectedReviewer(e.target.value);
                                    console.log('Selected reviewer:', e.target.value);  // Add this line
                                }}
                                required
                            >
                                <option value="">Select Reviewer</option>
                                {users.map((user) => (
                                    <option key={user.userId} value={user.userId}>
                                        {user.username}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <button type="submit" className="btn btn-success">Submit</button>
                    </form>
                </div>
            )}
        </div>
    );
};

export default ViewProject;
